module.exports = __webpack_public_path__ + "static/media/OpenSeas_web_3_preview.0f94a266.jpg";